// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__FE-ay","footer":"Form_footer__3Sp5S"};